module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLCz7Z1JlFd2JQEl8qw.96b6d546.woff2";